module.exports = __webpack_public_path__ + "static/media/telegram-brands.6d2d5d14.svg";